export function PWAUpdateBanner({ onUpdate, onDismiss }) {
  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-3 bg-white border border-gray-200 shadow-lg rounded-xl px-4 py-3 text-sm max-w-sm">
      <span className="text-lg flex-shrink-0">🔄</span>
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-gray-800">New version available</p>
        <p className="text-gray-500 text-xs">Reload to get the latest update.</p>
      </div>
      <div className="flex gap-2 flex-shrink-0">
        <button
          onClick={onUpdate}
          className="bg-sfp-orange text-white text-xs px-3 py-1.5 rounded-lg font-medium hover:opacity-90 transition-opacity"
        >
          Update
        </button>
        <button
          onClick={onDismiss}
          className="text-gray-400 text-xs px-2 py-1.5 rounded-lg hover:text-gray-600 transition-colors"
        >
          Later
        </button>
      </div>
    </div>
  )
}
